
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!content_migrations.subviews.import_quizzes_next_view";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'content-migrations/subviews/ImportQuizzesNextView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  
  return "style=\"color: #ccc;\"";
  }

function program3(depth0,data) {
  
  
  return "disabled=true";
  }

function program5(depth0,data) {
  
  
  return "checked";
  }

  buffer += "<label class=\"checkbox\" for=\"importQuizzesNext\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.quizzesNextEnabled), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n        <input type=\"checkbox\" id=\"importQuizzesNext\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.quizzesNextEnabled), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.migrationDefault), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "/>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "import_new_quizzes", "Import assessment content as New Quizzes", options) : helperMissing.call(depth0, "t", "import_new_quizzes", "Import assessment content as New Quizzes", options)))
    + "\n  <a href=\"#\" class=\"element_toggler\" style=\"margin-left: 10px\" aria-controls=\"import_quizzesNext_helpDialog\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "import_quizzesNext_help_label", "Import assessment as New Quizzes Help Icon", options) : helperMissing.call(depth0, "t", "import_quizzesNext_help_label", "Import assessment as New Quizzes Help Icon", options)))
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "import_quizzesNext_help_title_icon", "Import assessment as New Quizzes Help Icon", options) : helperMissing.call(depth0, "t", "import_quizzesNext_help_title_icon", "Import assessment as New Quizzes Help Icon", options)))
    + "\"><i class=\"icon-question\"></i></a>\n    <div id=\"import_quizzesNext_helpDialog\" data-read-on-open=\"true\" data-turn-into-dialog='{width\":600,\"modal\":true}' style=\"display:none\" title="
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "import_quizzesNext_help_title", "New Quizzes", options) : helperMissing.call(depth0, "t", "import_quizzesNext_help_title", "New Quizzes", options)))
    + ">\n    ";
  stack1 = (helper = helpers.__i18nliner_safe || (depth0 && depth0.__i18nliner_safe),options={hash:{},data:data},helper ? helper.call(depth0, "<p></p>", options) : helperMissing.call(depth0, "__i18nliner_safe", "<p></p>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'p_p': (stack1),
    'scope': ("content_migrations.subviews.import_quizzes_next_view")
  },data:data},helper ? helper.call(depth0, "import_new_quizzes_help_text", "New Quizzes is the new assessment engine for Canvas.%{p_p}To learn more, please contact your system administrator or visit", options) : helperMissing.call(depth0, "t", "import_new_quizzes_help_text", "New Quizzes is the new assessment engine for Canvas.%{p_p}To learn more, please contact your system administrator or visit", options)))
    + " <a href=\"https://community.canvaslms.com/t5/Instructor-Guide/tkb-p/Instructor\">Canvas Instructor Guide</a>.\n  </div>\n</label>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  